export default "__VITE_ASSET__DlFNu9Xu__"